// src/components/home/ProductHuntSpotlight.jsx
import React from "react";
import { FaProductHunt, FaShareAlt, FaCommentAlt } from "react-icons/fa";
import "./ProductHuntSpotlight.css";

const ProductHuntSpotlight = () => {
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: "BodhAI V2 Beta on Product Hunt",
        text: "Support BodhAI V2 Beta live on Product Hunt today!",
        url: "https://www.producthunt.com/products/bodhai/launches/bodhai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-bodhai",
      });
    } else {
      navigator.clipboard.writeText("https://www.producthunt.com/products/bodhai/launches/bodhai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-bodhai");
      alert("Product Hunt link copied to clipboard!");
    }
  };

  return (
    <section className="bvh-ph-spotlight-section" data-aos="fade-up">
      <div className="bvh-ph-spotlight-card">
        {/* Header Badge */}
        <div className="bvh-ph-spotlight-header">
          <div className="bvh-ph-badge-wrapper">
            <div className="bvh-ph-logo-badge">
              <FaProductHunt />
            </div>
            <div className="bvh-ph-tag-group">
              <span className="bvh-ph-tag">🚀 Featured Launch</span>
              <span className="bvh-ph-subtag">Product Hunt Product of the Day</span>
            </div>
          </div>

          <div className="bvh-ph-live-pill">
            <span className="bvh-ph-live-dot"></span> LIVE NOW
          </div>
        </div>

        {/* Content Title & Description */}
        <h2 className="bvh-ph-spotlight-title">
          BodhAI is now live on <span>Product Hunt!</span>
        </h2>
        <p className="bvh-ph-spotlight-desc">
          We're building BodhAI to create a smarter, AI-driven learning and exam preparation experience. 
          Every upvote, comment, and review empowers student developers globally!
        </p>

        {/* EXACT Product Hunt Embed Badges Code */}
        <div className="bvh-ph-official-widgets">
          {/* Badge 1: Featured Launch Badge */}
          <a href="https://www.producthunt.com/products/bodhai/launches/bodhai?embed=true&amp;utm_source=badge-featured&amp;utm_medium=badge&amp;utm_campaign=badge-bodhai" target="_blank" rel="noopener noreferrer" className="bvh-ph-widget-link">
            <img alt="BodhAI - Knowledge is the supreme wealth | Product Hunt" width="250" height="54" src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1180692&amp;theme=light&amp;t=1785003694826" className="bvh-ph-widget-img" />
          </a>

          {/* Badge 2: Follow Badge */}
          <a href="https://www.producthunt.com/products/bodhai?utm_source=badge-follow&amp;utm_medium=badge&amp;utm_source=badge-bodhai" target="_blank" rel="noopener noreferrer" className="bvh-ph-widget-link">
            <img src="https://api.producthunt.com/widgets/embed-image/v1/follow.svg?product_id=1255523&amp;theme=light" alt="BodhAI - Knowledge&#0032;is&#0032;the&#0032;supreme&#0032;wealth | Product Hunt" style={{ width: "250px", height: "54px" }} width="250" height="54" className="bvh-ph-widget-img" />
          </a>

          {/* Badge 3: Product Review Badge */}
          <a href="https://www.producthunt.com/products/bodhai/reviews/new?utm_source=badge-product_review&amp;utm_medium=badge&amp;utm_source=badge-bodhai" target="_blank" rel="noopener noreferrer" className="bvh-ph-widget-link">
            <img src="https://api.producthunt.com/widgets/embed-image/v1/product_review.svg?product_id=1255523&amp;theme=light" alt="BodhAI - Knowledge&#0032;is&#0032;the&#0032;supreme&#0032;wealth | Product Hunt" style={{ width: "250px", height: "54px" }} width="250" height="54" className="bvh-ph-widget-img" />
          </a>
        </div>

        {/* Action Buttons */}
        <div className="bvh-ph-spotlight-actions">
          <a
            href="https://www.producthunt.com/products/bodhai/launches/bodhai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-bodhai"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-ph-btn-main"
          >
            <FaProductHunt style={{ fontSize: "1.2rem" }} /> Visit Product Hunt
          </a>

          <button className="bvh-ph-btn-sub" onClick={handleShare}>
            <FaShareAlt /> Share Launch
          </button>

          <a
            href="https://www.producthunt.com/products/bodhai/reviews/new?utm_source=badge-product_review&utm_medium=badge&utm_source=badge-bodhai"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-ph-btn-sub"
          >
            <FaCommentAlt /> Write Review
          </a>
        </div>
      </div>
    </section>
  );
};

export default React.memo(ProductHuntSpotlight);
